import { render, staticRenderFns } from "./Kimler.vue?vue&type=template&id=305a3133&"
import script from "./Kimler.vue?vue&type=script&lang=js&"
export * from "./Kimler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports